import React from 'react';
import {FormattedMessage} from 'react-intl';

class Step extends React.Component {
  state = {};

  render() {
    var arrow = 'col-sm-1';

    if(!this.props.showArrow) {
      arrow = 'hide-component';
    }

    return (
      <div>
        <div className={this.props.showArrow ? 'col-sm-3' : 'col-sm-4'}>
          <h6 className="step-title"><FormattedMessage id="general.step" /> {this.props.number}.</h6>
          <p>{this.props.message}</p>
        </div>
        <div className={arrow}>
          <i className='bl bl-right_arrow' />
        </div>
      </div>
    );
  }
}

export default Step;
